import { defineStore } from 'pinia';
import MetaCampaignsAttributionAPI from 'dashboard/api/metaCampaignsAttribution';

export const useMetaCampaignsAttributionStore = defineStore(
  'metaCampaignsAttribution',
  {
    state: () => ({
      // keyed by conversation display id
      byConversation: {},
      uiFlags: {
        fetching: false,
        saving: false,
      },
    }),

    actions: {
      async fetch(conversationId) {
        this.uiFlags.fetching = true;
        try {
          const { data } =
            await MetaCampaignsAttributionAPI.getForConversation(
              conversationId
            );
          // A 204 (no attribution yet) comes back with an empty body.
          this.byConversation[conversationId] = data || null;
          return data;
        } catch (error) {
          this.byConversation[conversationId] = null;
          return null;
        } finally {
          this.uiFlags.fetching = false;
        }
      },

      async setCampaign(conversationId, campaignId) {
        this.uiFlags.saving = true;
        try {
          const { data } = await MetaCampaignsAttributionAPI.setForConversation(
            conversationId,
            campaignId
          );
          this.byConversation[conversationId] = data;
          return data;
        } finally {
          this.uiFlags.saving = false;
        }
      },

      async remove(conversationId) {
        this.uiFlags.saving = true;
        try {
          await MetaCampaignsAttributionAPI.removeForConversation(
            conversationId
          );
          this.byConversation[conversationId] = null;
        } finally {
          this.uiFlags.saving = false;
        }
      },
    },
  }
);
